import { Directive, EventEmitter, HostListener, Output, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Utils } from "sharedFeatures/utils";

declare var jQuery: any;

@Directive({
    selector: '[data-testid]'
})

export class TestidGTMDirective {

    constructor(private element: ElementRef) {
        //console.log('testid directive: ' + element);
    }

    @HostListener('click', ['$event'])
    clickEvent(event: Event) {
        if (event.srcElement) {
            var testid: string = jQuery(event.target).data("testid");
            var parentWithTestid: JQuery | undefined;

            if (!testid && event.target) {
                parentWithTestid = this.findParentWithTestid(event.target);

                if (parentWithTestid)
                    testid = parentWithTestid.data('testid');
            }

            if (testid) {
                //console.log(testid);
                Utils.GTMRecordTestidClick(testid);

                // rule for tour windows
                if (testid == "nextTourBtn") {
                    parentWithTestid = this.findParentWithTestid(jQuery(parentWithTestid).parent());
                    if (!parentWithTestid) return;
                    testid = parentWithTestid.data('testid');
                    Utils.GTMRecordTestidClick(testid);
                }
            }
        }
    }

    public findParentWithTestid(srcElement: EventTarget): JQuery | undefined {
        var result: JQuery | undefined = undefined;

        var testIdParent = jQuery(srcElement).closest("[data-testid]");

        if (testIdParent.length > 0) {
            result = jQuery(testIdParent[0]);
        }

        return result;
    }
}
